import { ChakraProvider, extendTheme } from '@chakra-ui/react'

import Header from 'src/layouts/BaseLayout/Header'

const fonts = {
  body: 'Roboto, sans-serif',
  heading: "'Roboto Slab', serif",
}

const theme = extendTheme({ fonts })

const BaseLayout = ({ children }) => {
  return (
    <ChakraProvider theme={theme}>
      <Header />
      {children}
    </ChakraProvider>
  )
}

export default BaseLayout
